import React, { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { ParentContain } from "./style/Home";
import { useSelector } from "react-redux";
import "./App.css";
import Sidebar from "./components/header/Sidebar";
import routes from "./routes";

const App = () => {
  const drawer = useSelector((state) => state.drawer);
  const location = useLocation();
  const navigate = useNavigate();

  const noSidebarRoutes = [
    "/",
    "/not-found",
    "/admin-login",
    "/forgot",
    "/verify-otp",
    "/send-otp",
    "/new-password",
    "/signup",
    "/forgotverify-otp",
    "/forgotsend-otp",
    "/exam",
  ];

  const publicRoutes = [
    "/",
    "/admin-login",
    "/not-found",
    "/forgot",
    "/verify-otp",
    "/send-otp",
    "/new-password",
    "/signup",
    "/forgotverify-otp",
    "/forgotsend-otp",
  ];

  const showHeaderFooter = !noSidebarRoutes.includes(location.pathname);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user_cred"));
    const token = userData?.token || null;

    if (userData && token) {
      if (userData.roleType === "admin") {
        if (location.pathname === "/" || location.pathname === "/admin-login") {
          navigate("/admin-dashboard");
        }
      } else if (userData.roleType === "user") {
        if (location.pathname === "/" || location.pathname === "/admin-login") {
          navigate("/dashboard");
        }
      }
    } else {
      // No authentication
      if (
        !publicRoutes.includes(location.pathname) &&
        location.pathname !== "/" &&
        location.pathname !== "/admin-login"
      ) {
        // Redirect to login if trying to access protected route
        navigate("/");
      }
    }
  }, [navigate, location.pathname]);

  return (
    <>
      {showHeaderFooter && <Sidebar />}
      <ParentContain
        className={showHeaderFooter ? (drawer ? "" : "DrawerOpen") : ""}
      >
        <Routes>
          {routes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Routes>
      </ParentContain>
    </>
  );
};

export default App;
